import { render, staticRenderFns } from "./AvailableTaxi.vue?vue&type=template&id=2fc5c9e2&scoped=true&"
import script from "./AvailableTaxi.vue?vue&type=script&lang=js&"
export * from "./AvailableTaxi.vue?vue&type=script&lang=js&"
import style0 from "./AvailableTaxi.vue?vue&type=style&index=0&id=2fc5c9e2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc5c9e2",
  null
  
)

export default component.exports